<template>
  <div class="card-on-card card-outline-secondary" id="informationLayout">
    <div class="card-header">
      <h5
        class="mb-2 font-weight-bold"
        v-if="!isLayoutBook && !isLayoutService"
      >
        Informasi Produk
      </h5>
      <h5 class="mb-2 font-weight-bold" v-if="isLayoutService">
        Informasi Jasa
      </h5>
      <h5 class="mb-2 font-weight-bold" v-if="isLayoutBook">Informasi Buku</h5>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <label
          v-if="!isLayoutService"
          class="col-lg-3 col-form-label form-control-label"
          >Nama Produk</label
        >
        <label
          v-if="isLayoutService"
          class="col-lg-3 col-form-label form-control-label"
          >Nama Jasa</label
        >
        <div class="col-lg-9">
          <input
            v-if="isLayoutService"
            class="form-control"
            name="productName"
            id="productName"
            type="text"
            v-model="sectionProductInformation.name"
            :readonly="isLayoutBook ? true : false"
            @keyup="seoRules('productName', 'productSeo')"
          />

          <input
            v-else
            class="form-control"
            name="productName"
            id="productName"
            type="text"
            v-model="sectionProductInformation.name"
            :readonly="isLayoutBook ? true : false"
          />
        </div>
      </div>
      <div class="form-group row d-none">
        <label class="col-lg-3 col-form-label form-control-label">SEO</label>
        <div class="col-lg-9">
          <input
            readonly
            class="form-control"
            name="productSeo"
            id="productSeo"
            type="text"
          />

          <input
            class="form-control"
            name="productTag"
            id="productTag"
            type="hidden"
          />
        </div>
      </div>
      <div :hidden="isLayoutService" class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >SK Kelulusan</label
        >
        <div class="col-lg-9">
          <input
            class="form-control"
            name="productSk"
            id="productSk"
            type="text"
            v-model="sectionProductInformation.skKelulusan"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Kategori</label
        >

        <!--jika buku -->

        <template v-if="isLayoutBook">
          <div v-if="isUpdateCategory" class="col">
            <div class="row">
              <div class="col-lg-3">
                <select
                  @change="getCategoryVal"
                  name="nonBookCategory"
                  id="nonBookCategory"
                  class="custom-select custom-select-sm is-invalid"
                >
                  <option value="" selected disabled>Pilih Kategoris </option>
                  <option
                    v-for="(lc, index) in listCategory"
                    :key="index"
                    :value="lc.id"
                  >
                    {{ lc.title }}
                  </option>
                </select>
              </div>

              <span id="loadingCategory1" class="d-none">
                <i class="fa fa-spinner fa-spin"></i>
              </span>

              <div class="col-lg-3">
                <select
                  @change="getSubCategoryVal"
                  name="nonBookSubCategory"
                  id="nonBookSubCategory"
                  class="custom-select custom-select-sm"
                >
                  <option value="" selected disabled>Pilih Kategori</option>
                  <option
                    v-for="(lsc, index) in listSubCategory"
                    :key="index"
                    :value="lsc.id"
                  >
                    {{ lsc.title }}
                  </option>
                  <!-- <option
                    v-for="(lc, index) in listCategory"
                    :key="index"
                    :value="index"
                  >
                    {{ lc.title }}
                  </option> -->
                </select>
              </div>

              <span id="loadingCategory2" class="d-none">
                <i class="fa fa-spinner fa-spin"></i>
              </span>

              <div class="col-lg-3">
                <!-- value update category di ambil dari class name -->
                <select
                  name="nonBookSub2Category"
                  id="nonBookSub2Category"
                  class="custom-select custom-select-sm bookSub2Category"
                >
                  <option value="" selected disabled>Pilih Kategori</option>
                  <option
                    v-for="(lsc, index) in listSub2Category"
                    :key="index"
                    :value="lsc.id"
                  >
                    {{ lsc.title }}
                  </option>
                </select>
              </div>
            </div>

            <button
              type="button"
              class="btn btn-danger"
              @click="updateCategory"
            >
              Batal Ubah
            </button>
          </div>
          <div v-if="isUpdateCategory === false" class="">
            <div class="col-lg-12">
              <span
                class="mr-3 badge badge-secondary pl-2 pr-2"
                style="font-size: 10.5px"
                id="parentCategory"
                >{{ currentCategory.first }}</span
              >
              <span
                class="mr-3 badge badge-secondary pl-2 pr-2"
                style="font-size: 10.5px"
                >{{ currentCategory.second }}</span
              >
              <span
                class="mr-3 badge badge-secondary pl-2 pr-2"
                style="font-size: 10.5px"
                >{{ currentCategory.third }}</span
              >
              <button
                type="button"
                class="btn btn-primary btn-sm btn-circle"
                @click="updateCategory"
              >
                <i class="fa fa-exchange-alt"></i>
              </button>
              <span class="small">Ubah Kategori</span>
            </div>
          </div>
        </template>

        <!-- Jika jasa -->
        <template v-if="isLayoutService">
          <div v-if="isUpdateCategory" class="col">
            <div class="row">
              <div class="col-lg-4">
                <select
                  @change="getCategoryVal"
                  name="nonBookCategory"
                  id="nonBookCategory"
                  class="form-control"
                >
                  <option
                    v-for="(lc, index) in listCategoryJasa"
                    :key="index"
                    :value="lc.id"
                  >
                    {{ lc.title }}
                  </option>
                </select>
              </div>

              <p id="loadingCategory1" class="mt-1 d-none small">
                Loading <i class="fa fa-spinner fa-spin"></i>
              </p>

              <div class="col-lg-5">
                <select
                  name="nonBookSubCategory"
                  id="nonBookSubCategory"
                  class="form-control"
                >
                  <option
                    v-for="(lsc, index) in listSubCategoryJasa"
                    :key="index"
                    :value="lsc.id"
                  >
                    {{ lsc.title }}
                  </option>
                </select>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-danger"
              @click="updateCategory"
            >
              Batal Ubah
            </button>
          </div>

          <div v-if="isUpdateCategory === false" class="">
            <div class="col-lg-12">
              <span
                class="mr-3 badge badge-secondary pl-2 pr-2"
                style="font-size: 10.5px"
                >{{ currentCategory.first }}</span
              >
              <span
                class="mr-3 badge badge-secondary pl-2 pr-2"
                style="font-size: 10.5px"
                >{{ currentCategory.second }}</span
              >
              <span
                class="mr-3 badge badge-secondary pl-2 pr-2"
                style="font-size: 10.5px"
                >{{ currentCategory.third }}</span
              >
              <button
                type="button"
                class="btn btn-primary btn-sm btn-circle"
                @click="updateCategory"
              >
                <i class="fa fa-exchange-alt"></i>
              </button>
              <span class="small">Ubah Kategori</span>
            </div>
          </div>
        </template>

        <!--jika bbaranng / non buku -->

        <template v-if="!isLayoutBook && !isLayoutService">
          <div v-if="isUpdateCategory" class="col">
            <div class="row">
              <div class="col-lg-3">
                <select
                  @change="getCategoryVal"
                  name="nonBookCategory"
                  id="nonBookCategory"
                  class="custom-select custom-select-sm is-invalid"
                >
                  <option value="" selected disabled>Pilih Kategori</option>
                  <option
                    v-for="(lc, index) in listCategory"
                    :key="index"
                    :value="lc.id"
                  >
                    {{ lc.title }}
                  </option>
                </select>
              </div>

              <span id="loadingCategory1" class="d-none">
                <i class="fa fa-spinner fa-spin"></i>
              </span>

              <div class="col-lg-3">
                <select
                  @change="getSubCategoryVal"
                  name="nonBookSubCategory"
                  id="nonBookSubCategory"
                  class="custom-select custom-select-sm"
                  :disabled="listSubCategory.length === 0"
                >
                  <option value="" selected disabled>Pilih Kategori</option>
                  <option
                    v-for="(lsc, index) in listSubCategory"
                    :key="index"
                    :value="lsc.id"
                  >
                    {{ lsc.title }}
                  </option>
                </select>
              </div>

              <span id="loadingCategory2" class="d-none">
                <i class="fa fa-spinner fa-spin"></i>
              </span>

              <div class="col-lg-3">
                <!-- value update category di ambil dari class name -->
                <select
                  name="nonBookSub2Category"
                  id="nonBookSub2Category"
                  class="custom-select custom-select-sm bookSub2Category"
                  :disabled="listSub2Category.length === 0"
                >
                  <option value="" selected disabled>Pilih Kategori</option>
                  <option
                    v-for="(lsc, index) in listSub2Category"
                    :key="index"
                    :value="lsc.id"
                  >
                    {{ lsc.title }}
                  </option>
                </select>
              </div>
            </div>

            <button
              type="button"
              class="btn btn-danger"
              @click="updateCategory"
            >
              Batal Ubah
            </button>
          </div>
          <div v-if="isUpdateCategory === false" class="">
            <div class="col-lg-12">
              <span
                class="mr-3 badge badge-secondary pl-2 pr-2"
                style="font-size: 10.5px"
                >{{ currentCategory.first }}</span
              >
              <span
                class="mr-3 badge badge-secondary pl-2 pr-2"
                style="font-size: 10.5px"
                >{{ currentCategory.second }}</span
              >
              <span
                class="mr-3 badge badge-secondary pl-2 pr-2"
                style="font-size: 10.5px"
                >{{ currentCategory.third }}</span
              >
              <button
                type="button"
                class="btn btn-primary btn-sm btn-circle"
                @click="updateCategory"
              >
                <i class="fa fa-exchange-alt"></i>
              </button>
              <span class="small">Ubah Kategori</span>
            </div>
          </div>
        </template>
      </div>
      <div :hidden="isLayoutService" class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Merek / Brand / Penerbit</label
        >
        <div class="col-lg-9">
          <select
            name="productManufacturer"
            id="productManufacturer"
            class="form-control"
          >
            <option
              :selected="merek.isSelected"
              :value="merek.value"
              class="form-control"
              v-for="merek in sectionProductInformation.manufacturer"
              :key="merek.value"
            >
              {{ merek.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label">Kode</label>
        <div :class="isLayoutService ? 'col-lg-9' : 'col-lg-4'">
          <div class="input-group">
            <div class="input-group-prepend">
              <span
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                id=""
                >SKU</span
              >
            </div>
            <input
              v-model="sectionProductInformation.sku"
              name="productCode"
              id="productCode"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-lg-5">
          <div :hidden="isLayoutService" class="input-group">
            <div class="input-group-prepend">
              <span
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                id=""
                >ISBN</span
              >
            </div>
            <input
              v-model="sectionProductInformation.isbn"
              name="productIsbn"
              id="productIsbn"
              type="text"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="form-group row" v-if="isLayoutService">
        <label class="col-lg-3 col-form-label form-control-label"
          >Lama Pengerjaan</label
        >

        <div class="col-lg-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <input
                class="form-control"
                type="number"
                name="duration"
                id="duration"
                :value="sectionProductInformation.workDuration"
                step="1"
                min="0"
                @keyup="durationValidation('duration')"
                onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
              />
              <span
                class="p-1 input-group-text mb-2 mt-0"
                style="font-size: 12px; font-weight: 500"
                >Hari</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-lg-2 col-form-label form-control-label"
          >Deskripsi</label
        >
        <div class="col-lg-10 offset-md-2">
          <!-- <wysiwyg
                            v-model="sectionProductInformation.description"
                          /> -->
          <quill-editor
            ref="myQuillEditor"
            @change="onEditorChange($event)"
            name="updateDescription"
            v-model="sectionProductInformation.description"
          />
          <!-- <p style="white-space: pre-line">
                            {{ products.productDes }}
                          </p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
// import axios from "axios";
import $ from "jquery";

export default {
  data() {
    return {
      currentCategory: {
        first: "",
        second: "",
        third: "",
      },
    };
  },
  components: {
    quillEditor,
  },
  props: {
    isLayoutBook: Boolean,
    sectionProductInformation: {},
    description: String,
    onEditorChange: Function,
    getCategoryVal: Function,
    listPenerbit: Array,
    listCategory: Array,
    listSubCategory: Array,
    getSubCategoryVal: Function,
    listSub2Category: Array,
    listCategoryJasa: Array,
    listSubCategoryJasa: Array,
    isUpdateCategory: Boolean,
    updateCategory: Function,
    isLayoutService: Boolean,
  },
  updated() {
    // if(!this.isLayoutService && !this.isLayoutBook){

    this.currentCategory.first = this.sectionProductInformation.categoryChildren[0].name;

    this.currentCategory.second =
      typeof this.sectionProductInformation.categoryChildren[1] == "undefined"
        ? ""
        : this.sectionProductInformation.categoryChildren[1].name;

    this.currentCategory.third =
      typeof this.sectionProductInformation.categoryChildren[2] == "undefined"
        ? ""
        : this.sectionProductInformation.categoryChildren[2].name;

    // try {
    //   this.currentCategory.third
    // } catch (err) {
    //   console.log(err)
    // }
    // }
    // console.log(this.sectionProductInformation)
    this.seoRules("productName", "productSeo");
  },

  mounted() {
    console.log("props listSubCategory:", this.listSubCategory);
  },
  watch: {
    listSubCategory(val) {
      console.log("listSubCategory updated:", val);
    },
  },
  methods: {
    seoRules(first, replace) {
      let string = this.$route.params.id + "-" + $("#" + first).val() + "-";
      let string_tag = $("#" + first).val() + "-";

      let nilai = string.toLowerCase();
      let nilai_tag = string_tag.toLowerCase();

      let dan = nilai.split(/[&]/g).join(" dan ");
      let dan_tag = nilai_tag.split(/[&]/g).join(" dan ");
      let str_tag = dan_tag.split(/[^a-z0-9-A-Z]/g).join(", ");
      let str = dan.split(/[^a-z0-9-A-Z]/g).join(", ");
      let str2 = dan.split(/[^a-z0-9-A-Z]/g).join("-");

      $("#" + replace).val(str);
      $("#productSeo").val(str2);

      $("#productTag").val(str_tag);
    },
    durationValidation(param) {
      if ($(`#${param}`).val() == 0 || $(`#${param}`).val() == "") {
        $(`#${param}`).addClass("is-invalid");
      } else {
        $(`#${param}`).removeClass("is-invalid");
      }
    },
  },
  // computed: {
  //   editor() {
  //     return this.$refs.myQuillEditor.quill
  //   }
  // },
};
</script>
